import {delegate} from './lib/events';
import {mutate} from './lib/promise-fastdom';

export default function () {
    const root = document.documentElement;

    // to handle scroll-margin
    document.addEventListener('focusin', delegate('.nav', mutate(function () {
        root.classList.add('nav-focused');
    })), {passive: true});
    document.addEventListener('focusout', delegate('.nav', mutate(function () {
        root.classList.remove('nav-focused');
    })), {passive: true});

    document.addEventListener('nav/before-open', mutate(function () {
        root.classList.add('nav-on');
    }), {passive: true});
    document.addEventListener('nav/after-close', mutate(function () {
        root.classList.remove('nav-on');
    }), {passive: true});
}